import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { SettingsProvider } from "@/contexts/SettingsContext";

import Home from "@/pages/Home";
import Weddings from "@/pages/Weddings";
import WeddingDetail from "@/pages/WeddingDetail";
import Reels from "@/pages/Reels";
import Moodboards from "@/pages/Moodboards";
import Stories from "@/pages/Stories";
import About from "@/pages/About";

import AdminLogin from "@/pages/admin/Login";
import WeddingsAdmin from "@/pages/admin/WeddingsAdmin";
import ReelsAdmin from "@/pages/admin/ReelsAdmin";
import MoodboardsAdmin from "@/pages/admin/MoodboardsAdmin";
import StoriesAdmin from "@/pages/admin/StoriesAdmin";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";

function App() {
  return (
    <SettingsProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/weddings" element={<Weddings />} />
            <Route path="/weddings/:slug" element={<WeddingDetail />} />
            <Route path="/reels" element={<Reels />} />
            <Route path="/moodboards" element={<Moodboards />} />
            <Route path="/stories" element={<Stories />} />
            <Route path="/about" element={<About />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<WeddingsAdmin />} />
            <Route path="/admin/reels" element={<ReelsAdmin />} />
            <Route path="/admin/moodboards" element={<MoodboardsAdmin />} />
            <Route path="/admin/stories" element={<StoriesAdmin />} />
            <Route path="/admin/settings" element={<SettingsAdmin />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </SettingsProvider>
  );
}

export default App;
